import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { IconName } from "@enersis/gp-components/gp-icon";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "tpm-icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["./icon.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent {
  @Input() public icon: IconName | string;
}
